import { store } from './store.js';
export function AddToCart(props){
	return{
		store,
		data: {
			...props,
			_nonce: wpData.nonce,
			action: 'add_to_cart',
		},

		SubmitData(){
			console.log('AddToCart', this.data);
			store.showRotateLogo = true;
			store.SendAjaxRequest(this.data)
				.then(response => {
					if (!response.success) throw new Error(response);
					store.cart = response.data.cart;
					this.data.quantity = 1;
					this.data.stock = response.data.product.stock;
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						'event': 'addToCart',
						'message': response.data.message,
						'data': response.data,
						'ecommerce': {
							'currency': response.data.currency,
							'value': Number(response.data.product.price) * Number(response.data.product.count),
							'items': [
								{
									'item_id': response.data.product.id,        // обязательное поле для GA4
									'item_name': response.data.product.name,    // название товара
									'price': Number(response.data.product.price),
									'quantity': Number(response.data.product.count)
								}
							]
						}
					});
				})
				.catch(console.error)
				.finally(() => store.showRotateLogo = false);
		},
	}
}